// Handle button styling when variant is selected - Fixed approach
document.addEventListener('DOMContentLoaded', function () {

    const buyButtons = document.querySelectorAll('.custom-buy-buttons .product-form__submit');

    // Check if product has variants
    const variantSelectors = document.querySelectorAll('variant-selects');
    const hasVariants = variantSelectors.length > 0;

    // Track if user has actually made a selection
    let userHasInteracted = !hasVariants; // If no variants, user doesn't need to interact

    // Check if we should auto-preselect a variant
    let autoPreselectedVariantId = null;

    if (hasVariants && window.productVariants && Array.isArray(window.productVariants)) {
        const variants = window.productVariants;
        const availableVariants = variants.filter(v => v.available);

        if (variants.length === 1) {
            // Product has only 1 variant: preselect it
            autoPreselectedVariantId = variants[0].id;
        } else if (availableVariants.length === 1) {
            // Multiple variants but only 1 in stock: preselect the available one
            autoPreselectedVariantId = availableVariants[0].id;
        }
    }

    if (hasVariants && !autoPreselectedVariantId) {
        // Clear initial variant ID — force user to select
        const variantIdInputs = document.querySelectorAll('input[name="id"]');
        variantIdInputs.forEach(input => {
            input.value = '';
            input.removeAttribute('value');
        });
    } else if (hasVariants && autoPreselectedVariantId) {
        // Auto-preselect: set variant ID and check the right radio buttons
        userHasInteracted = true;
        const variantIdInputs = document.querySelectorAll('input[name="id"]');
        variantIdInputs.forEach(input => {
            input.value = autoPreselectedVariantId;
        });

        // Find the variant to preselect and check its option radio buttons
        const variant = window.productVariants.find(v => v.id === autoPreselectedVariantId);
        if (variant) {
            let lastCheckedRadio = null;
            // Select the correct radio button for each option
            variant.options.forEach((optionValue, optionIndex) => {
                const radios = document.querySelectorAll(
                    `variant-selects input[type="radio"][name*="-${optionIndex + 1}"]`
                );
                radios.forEach(radio => {
                    if (radio.value === optionValue) {
                        radio.checked = true;
                        lastCheckedRadio = radio;
                    }
                });

                // Also update the [data-selected-value] display text for swatch pickers
                const fieldset = radios[0]?.closest('.product-form__input');
                if (fieldset) {
                    const selectedValueEl = fieldset.querySelector('[data-selected-value]');
                    if (selectedValueEl) selectedValueEl.textContent = optionValue;
                }
            });

            // Dispatch change event so VariantSelects + product-info update the full UI
            if (lastCheckedRadio) {
                // Suppress focus ring from programmatic selection
                const noFocusStyle = document.createElement('style');
                noFocusStyle.textContent = '.product-form__input--pill input[type="radio"]:focus-visible+label,.product-form__input--pill input[type="radio"].focused+label{box-shadow:none!important}';
                document.head.appendChild(noFocusStyle);

                lastCheckedRadio.dispatchEvent(new Event('change', { bubbles: true }));
                lastCheckedRadio.blur();

                // Remove suppression on first real user click so focus-visible works normally after
                document.addEventListener('pointerdown', function () {
                    noFocusStyle.remove();
                }, { once: true });
            }
        }
    }

    // Get product price
    let productPrice = '';
    const priceElement = document.querySelector('.price .price__regular .price-item--regular') ||
        document.querySelector('.price .price-item--regular') ||
        document.querySelector('.product__price .price-item--regular') ||
        document.querySelector('[data-price]') ||
        document.querySelector('.price');

    if (priceElement) {
        productPrice = priceElement.textContent.trim();
    }

    function updateButtonState() {
        // Re-grab price each time in case variant changed the displayed price element
        const livePriceElement = document.querySelector('.price .price__regular .price-item--regular') ||
            document.querySelector('.price .price-item--regular') ||
            document.querySelector('.product__price .price-item--regular') ||
            document.querySelector('[data-price]') ||
            document.querySelector('.price');
        if (livePriceElement) {
            productPrice = livePriceElement.textContent.trim();
        }

        buyButtons.forEach(button => {
            const priceSpan = button.querySelector('.button-price');
            const textSpan = button.querySelector('.button-text');
            if (!priceSpan || !textSpan) return;

            if (productPrice) {
                const clean = productPrice.replace(/\s*EUR$/i, '');
                priceSpan.textContent = `${clean} EUR`;

                // Update data attribute for quantity calculation
                const priceMatch = clean.match(/(\d+(?:[.,]\d+)*(?:[.,]\d{2})?)/);
                if (priceMatch) {
                    let priceValue = priceMatch[1].replace(/[.,]/g, '');
                    // If the last two digits represent cents, keep them as such
                    if (priceValue.length > 2) {
                        priceValue = priceValue.slice(0, -2) + '.' + priceValue.slice(-2);
                    }
                    const priceInCents = Math.round(parseFloat(priceValue) * 100);
                    priceSpan.setAttribute('data-variant-price', priceInCents);
                }
            }

            if (userHasInteracted) {
                button.classList.add('variant-selected');
                button.removeAttribute('aria-disabled');
                textSpan.textContent = window.variantStrings?.addToCart || 'Add to Cart';

                // Update compare at price color when button is selected (yellow)
                const compareAtPrice = button.querySelector('.compare-at-price');
                if (compareAtPrice) {
                    compareAtPrice.style.color = 'rgb(var(--color-apt-clay), 0.3)';
                }
            } else {
                button.classList.remove('variant-selected');
                button.setAttribute('aria-disabled', 'true');
                textSpan.textContent = window.variantStrings?.selectSize || 'Select Size';

                // Reset compare at price color when button is not selected
                const compareAtPrice = button.querySelector('.compare-at-price');
                if (compareAtPrice) {
                    compareAtPrice.style.color = 'rgb(var(--color-apt-clay), 0.3)';
                }
            }
        });

        // Trigger quantity price update
        document.dispatchEvent(new CustomEvent('variant:change'));
    }

    // Listen for clicks on variant/size inputs
    document.addEventListener('click', function (e) {
        // Check if clicked element is a variant input or its label
        if (e.target.type === 'radio' ||
            (e.target.tagName === 'LABEL' && e.target.getAttribute('for'))) {

            userHasInteracted = true;

            // Set the variant ID when user selects
            setTimeout(() => {
                const checkedInput = document.querySelector('input[type="radio"]:checked');
                if (checkedInput) {
                    const variantId = checkedInput.getAttribute('data-variant-id') ||
                        checkedInput.getAttribute('data-option-value-id') ||
                        checkedInput.value;

                    const variantIdInputs = document.querySelectorAll('input[name="id"]');
                    variantIdInputs.forEach(input => {
                        input.value = variantId;
                    });
                }
                updateButtonState();
            }, 100);
        }
    });

    // Prevent form submission when no variant is selected
    buyButtons.forEach(button => {
        button.addEventListener('click', function (e) {
            if (!userHasInteracted && hasVariants) {
                e.preventDefault();
                e.stopPropagation();
                // Show some visual feedback
                button.style.animation = 'shake 0.5s';
                setTimeout(() => button.style.animation = '', 500);

                return false;
            }
        });
    });

    // Initial state
    updateButtonState();
});
